export const IS_SERVER = typeof window === 'undefined'
